module.exports = __webpack_public_path__ + "static/media/3-BIM安装计量GDQ.83b923ff.png";